import APIService from "./APIService";

const API_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT + "extension-status";

export default {
  getEmbededBlockStatus() {
    return APIService.get(API_END_POINT);
  }
}